<template>
    <div v-if="dataInfo" style="padding-bottom:50px;">
      <TemplateTop :code="code" @onClick="getInfo"/>
        <div class="titleStyle">
                <!-- <div class="titleFont">{{dataInfo.title}}</div>
                <div class="conentFont" v-if="dataInfo.englishTitle">
                    <div class="divide"></div>
                    <span class="enFont">{{dataInfo.englishTitle}}</span>
                    <div class="divide"></div>
                </div> -->
            </div>
        <div class="enterpriseHonorList">
            <div
                v-for="(item, idx) in infoList"
                :key="idx"
                :class="[
                    'enterpriseHonorItem',
                    idx >= 8 ? 'enterpriseHonorItemHide' : '',
                ]"
            >
                <img :src="item.image" class="enterpriseHonorItemImg" />
                <div class="enterpriseHonorItemTitle">{{item.title}}</div>
            </div>
        </div>
        <div class="enterpriseHonorBtn" v-show="infoList.length > 8">
            <div class="moreBtn" @click="clickBtn">
                {{ enterpriseHonorBtnFont }}
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import TemplateTop from "@/components/TemplateTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "EnterpriseHonor",
    components: {
        TemplateTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryArtListCmsArticleCategoryByCode",
            dataInfo:null,
            infoList: [],
            canShow: false,
            enterpriseHonorBtnFont: "更多荣誉",
            isMore: true,
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        clickBtn() {
            this.isMore = !this.isMore;
            this.enterpriseHonorBtnFont = this.isMore ? "更多荣誉" : "收起";
            $(".enterpriseHonorItemHide").slideToggle(300);
        },
        getInfo() {
            this.code = this.$route.query.code?this.$route.query.code:"";
            let that = this;
            let parmas = {
                code: this.code,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.dataInfo = res.result[0];
                    that.infoList = res.result[0].cmsArticleList;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 10px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.enterpriseHonorList {
    .typeArea();
    display: flex;
    flex-wrap: wrap;
    .enterpriseHonorItem {
        padding: 10px;
        width: 25%;
        .enterpriseHonorItemImg {
            width: 100%;
            height: 200px;
        }
        .enterpriseHonorItemTitle{
            text-align: center;
            // font-size: 16px;
            font-weight: bold;
            padding: 10px;
        }
    }
    .enterpriseHonorItemHide {
        display: none;
    }
    .enterpriseHonorItem:hover {
        .enterpriseHonorItemImg {
            transition: all 0.3s;
            transform: scale(1.1);
        }
    }
}
.enterpriseHonorBtn {
    margin: 50px 0;
    display: flex;
    justify-content: center;
    .moreBtn {
        width: 190px;
        background-color: white;
        border-radius: 2px;
        padding: 16px 58px;
        font-size: 18px;
        color: #333333;
        border: solid 1px #333333;
        text-align: center;
    }
    .moreBtn:hover {
        cursor: pointer;
        background-color: #0052d9;
        color: #ffffff;
    }
}
</style>